module.exports = __webpack_public_path__ + "img/topindicator9.57e32750.png";